import React, { useContext } from 'react';
import styled from '@emotion/styled';
import type { WCmsHomepageSectionView } from '@zola/svc-web-api-ts-client';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { mapFullFontViewToSerializedStyles } from 'components/publicWebsiteV2/util/mappers';
import { ThemeContext } from '../../../../context';

const Story = ({
  title,
  subtitle,
  description,
}: Pick<WCmsHomepageSectionView, 'title' | 'subtitle' | 'description'>): JSX.Element => {
  const {
    components: { cmsEntityComponentHeaderFontValues, cmsEntityComponentBodyFontValues },
    wedding,
  } = useContext(ThemeContext);
  const storyComponent = wedding?.public_theme_v2?.components?.CMS_ENTITY;

  const orientation = storyComponent?.option_type_values?.ORIENTATION?.value;
  const Container = styled.div`
    display: flex;
    flex-direction: ${orientation === 'HORIZONTAL' ? 'row' : 'column'};
    // TODO: CENTERING
    text-align: center;
    ${MEDIA_QUERY.MOBILE} {
      flex-direction: column;
    }
  `;

  const StoryTitle = styled.h3`
    ${mapFullFontViewToSerializedStyles(cmsEntityComponentHeaderFontValues)}
  `;

  const Subtitle = styled.div`
    ${mapFullFontViewToSerializedStyles(cmsEntityComponentBodyFontValues)}
    margin-top: 12px;
    margin-bottom: 24px;
  `;
  const Subcontainer = styled.div`
    ${orientation === 'HORIZONTAL' &&
    `width: 50%;
    display: flex; 
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    padding: 32px;
    `}
    ${MEDIA_QUERY.MOBILE} {
      width: 100%;
      padding: 0;
    }
  `;

  const TitleContainer = styled(Subcontainer)`
    ${orientation === 'HORIZONTAL' &&
    `border-right: 1px solid #${cmsEntityComponentBodyFontValues.color};`}
    ${MEDIA_QUERY.MOBILE} {
      border: none;
    }
  `;

  const StoryDescription = styled.p`
    ${mapFullFontViewToSerializedStyles(cmsEntityComponentBodyFontValues)}
  `;

  return (
    <Container>
      <TitleContainer>
        <StoryTitle>{title}</StoryTitle>
        <Subtitle>{subtitle}</Subtitle>
      </TitleContainer>
      <Subcontainer>
        <StoryDescription>{description}</StoryDescription>
      </Subcontainer>
    </Container>
  );
};

export default Story;
